var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/lodash/_Symbol.js
// module id = S8m2
// module chunks = 1